import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { sentenceClausesData, getDataForDifficulty } from '../courses/data/grammar/sentenceClauses';

export default function SentenceClauseTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : sentenceClausesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
